import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import './DefaultButton.scss';

const DefaultButton = ({children, variant = 'contained', type = 'button', to, formAction, disabled, onClick, loading, classes = '', lastElemInGroup = false, size = ''}) => {
    const sizeClass = size ? `default_button_${size}` : '';
    if(type === 'link') {
        return (
            <div className="default_button_wrapper">
                <Button
                    component={Link}
                    to={to}
                    variant={variant}
                    classes={{
                        root: `default_button default_button_${variant} ${sizeClass} ${classes}`
                    }}
                >
                    {children}
                </Button>
            </div>
        );
    } else  {
        return (
            <div className={`default_button_wrapper ${lastElemInGroup ? 'default_button_wrapper--last_btn' : ''}`}>
                <Button
                    type={formAction ? 'submit' : 'button'}
                    variant={variant}
                    disabled={disabled}
                    onClick={onClick}
                    classes={{
                        root: `default_button default_button_${variant} ${sizeClass} ${classes}`
                    }}
                >
                    {loading
                        ? <CircularProgress size={24} />
                        : children
                    }
                </Button>
            </div>
        );
    }

};

export default DefaultButton;